export const rawUserData = [
  {
    "Date": "2014-01-07",
    "зріст": 195,
    "вага": 87,
    "стегно": 56,
    "груди": 106,
    "рука": 32,
    "живіт": 88,
    "шия": 38,
    "кість": null,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2014-10-23",
    "зріст": 195,
    "вага": 87,
    "стегно": 56,
    "груди": 106,
    "рука": 35,
    "живіт": 92,
    "шия": 38,
    "кість": 18,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2016-01-10",
    "зріст": 193,
    "вага": 95,
    "стегно": 59.5,
    "груди": 108,
    "рука": 38.5,
    "живіт": 94,
    "шия": 38.2,
    "кість": null,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2017-01-17",
    "зріст": 192,
    "вага": 96,
    "стегно": 58,
    "груди": 109,
    "рука": 36.5,
    "живіт": 100,
    "шия": 38.5,
    "кість": 18,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2018-01-13",
    "зріст": 192,
    "вага": 95,
    "стегно": 57,
    "груди": 110,
    "рука": 36,
    "живіт": 102,
    "шия": 40,
    "кість": null,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2020-02-27",
    "зріст": 192,
    "вага": 94.5,
    "стегно": 58,
    "груди": 108.5,
    "рука": 37,
    "живіт": 98.5,
    "шия": 41.5,
    "кість": 19,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2020-07-03",
    "зріст": 192,
    "вага": 89.9,
    "стегно": 57.2,
    "груди": 105.5,
    "рука": 37,
    "живіт": 95.45,
    "шия": 39,
    "кість": 19,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2020-08-21",
    "зріст": 192,
    "вага": 91.5,
    "стегно": 58.1,
    "груди": 106.5,
    "рука": 36.9,
    "живіт": 95.65,
    "шия": 40.51,
    "кість": 18.24,
    "сидниці": null,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2021-01-04",
    "зріст": 192,
    "вага": 92.9,
    "стегно": 57.5,
    "груди": 105.5,
    "рука": 36.5,
    "живіт": 98.75,
    "шия": 42,
    "кість": 19,
    "сидниці": 100.5,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2021-03-09",
    "зріст": 192,
    "вага": null,
    "стегно": 59.7,
    "груди": 106.45,
    "рука": 38,
    "живіт": 96.1,
    "шия": 40.5,
    "кість": 18.8,
    "сидниці": 104,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2021-10-23",
    "зріст": 192,
    "вага": 92.9,
    "стегно": 59,
    "груди": 106.25,
    "рука": 37.2,
    "живіт": 99.25,
    "шия": 40.5,
    "кість": 19.1,
    "сидниці": 101.5,
    "гомілка": 39.4,
    "Примітка": null
  },
  {
    "Date": "2022-01-08",
    "зріст": 192,
    "вага": 94.4,
    "стегно": 59,
    "груди": 106.5,
    "рука": 38.4,
    "живіт": 99,
    "шия": 41,
    "кість": 19.2,
    "сидниці": 102.5,
    "гомілка": 38.5,
    "Примітка": null
  },
  {
    "Date": "2022-02-25",
    "зріст": 192,
    "вага": 93.3,
    "стегно": 59,
    "груди": 106.5,
    "рука": 37.8,
    "живіт": 99,
    "шия": 41,
    "кість": 19.2,
    "сидниці": 102.5,
    "гомілка": 38.5,
    "Примітка": null
  },
  {
    "Date": "2022-05-22",
    "зріст": 192,
    "вага": 94.5,
    "стегно": 59.1,
    "груди": 107.25,
    "рука": 37,
    "живіт": 101.5,
    "шия": null,
    "кість": 18.5,
    "сидниці": 103,
    "гомілка": 39,
    "Примітка": null
  },
  {
    "Date": "2022-08-15",
    "зріст": 192,
    "вага": 92.3,
    "стегно": 58.3,
    "груди": 103.5,
    "рука": 37.2,
    "живіт": 97.1,
    "шия": null,
    "кість": 19,
    "сидниці": 101,
    "гомілка": 38,
    "Примітка": null
  },
  {
    "Date": "2022-09-14",
    "зріст": 192,
    "вага": 92.8,
    "стегно": 58.8,
    "груди": 104.3,
    "рука": 38.5,
    "живіт": 96.25,
    "шия": null,
    "кість": 19,
    "сидниці": 103.3,
    "гомілка": 38,
    "Примітка": null
  },
  {
    "Date": "2022-11-23",
    "зріст": 192,
    "вага": 92,
    "стегно": 56.5,
    "груди": 105.8,
    "рука": 36.8,
    "живіт": 98.2,
    "шия": null,
    "кість": 18.8,
    "сидниці": 103.3,
    "гомілка": null,
    "Примітка": null
  },
  {
    "Date": "2023-01-03",
    "зріст": 192,
    "вага": 96.3,
    "стегно": 58.8,
    "груди": 105.75,
    "рука": 37.8,
    "живіт": 100.5,
    "шия": null,
    "кість": null,
    "сидниці": 103,
    "гомілка": 38.2,
    "Примітка": null
  },
  {
    "Date": "2023-03-01",
    "зріст": 192,
    "вага": 101,
    "стегно": 59.5,
    "груди": 106.5,
    "рука": 40.5,
    "живіт": 104,
    "шия": null,
    "кість": 19,
    "сидниці": 106,
    "гомілка": 38.5,
    "Примітка": null
  },
  {
    "Date": "2023-03-18",
    "зріст": 192,
    "вага": 102,
    "стегно": 61.3,
    "груди": 108.75,
    "рука": 40,
    "живіт": 104.5,
    "шия": null,
    "кість": null,
    "сидниці": 106,
    "гомілка": 39,
    "Примітка": null
  },
  {
    "Date": "2023-06-04",
    "зріст": 192,
    "вага": 98.8,
    "стегно": 59.3,
    "груди": 106,
    "рука": 39.5,
    "живіт": 101.75,
    "шия": null,
    "кість": null,
    "сидниці": 105,
    "гомілка": 39,
    "Примітка": null
  },
  {
    "Date": "2023-09-28",
    "зріст": 192,
    "вага": 99.8,
    "стегно": 59.3,
    "груди": 106.75,
    "рука": 38,
    "живіт": 104.5,
    "шия": null,
    "кість": 19.2,
    "сидниці": 105,
    "гомілка": 40,
    "Примітка": null
  },
  {
    "Date": "2024-01-17",
    "зріст": 192,
    "вага": 95,
    "стегно": 57,
    "груди": 102,
    "рука": 34.5,
    "живіт": 99,
    "шия": null,
    "кість": 17.8,
    "сидниці": 101.5,
    "гомілка": 37.5,
    "Примітка": null
  },
  {
    "Date": "2024-08-15",
    "зріст": 192,
    "вага": 97.5,
    "стегно": 56.8,
    "груди": 104.65,
    "рука": 36.7,
    "живіт": 101.25,
    "шия": null,
    "кість": 18,
    "сидниці": 103,
    "гомілка": 38.4,
    "Примітка": null
  },
  {
    "Date": "2025-01-30",
    "зріст": 192,
    "вага": 94.55,
    "стегно": 58,
    "груди": 105.5,
    "рука": 36.5,
    "живіт": 99,
    "шия": null,
    "кість": 17.7,
    "сидниці": 103,
    "гомілка": 35.6,
    "Примітка": null
  },
  {
    "Date": "2025-03-17",
    "зріст": 192,
    "вага": 91,
    "стегно": 55,
    "груди": 103.75,
    "рука": 36.5,
    "живіт": 95,
    "шия": null,
    "кість": 17.5,
    "сидниці": 99.3,
    "гомілка": 35.6,
    "Примітка": null
  },
  {
    "Date": "2025-04-03",
    "зріст": 192,
    "вага": 89.4,
    "стегно": 55,
    "груди": 103.75,
    "рука": 36.5,
    "живіт": 95,
    "шия": null,
    "кість": 17.5,
    "сидниці": 99.3,
    "гомілка": 35.6,
    "Примітка": null
  },
  {
    "Date": "2025-05-22",
    "зріст": 192,
    "вага": 89.95,
    "стегно": 58,
    "груди": 106.9,
    "рука": 37.5,
    "живіт": 96.75,
    "шия": null,
    "кість": 19.5,
    "сидниці": 101.5,
    "гомілка": 38.5,
    "Примітка": null
  },
  {
    "Date": "2025-07-03",
    "зріст": 192,
    "вага": 94,
    "стегно": 58.5,
    "груди": 109.5,
    "рука": 38.4,
    "живіт": 99.25,
    "шия": null,
    "кість": 19.5,
    "сидниці": 102.5,
    "гомілка": 38,
    "Примітка": null
  },
  {
    "Date": "2025-08-28",
    "зріст": 192,
    "вага": 95,
    "стегно": 58,
    "груди": 109.5,
    "рука": 37.7,
    "живіт": 99.25,
    "шия": null,
    "кість": 19.5,
    "сидниці": 103.5,
    "гомілка": 38.8,
    "Примітка": null
  },
  {
    "Date": "2025-11-11",
    "зріст": 192,
    "вага": 90,
    "стегно": 57,
    "груди": 106.75,
    "рука": 38.3,
    "живіт": 97,
    "шия": null,
    "кість": 19,
    "сидниці": 102.3,
    "гомілка": 38.5,
    "Примітка": null
  },
  {
    "Date": "2025-12-31",
    "зріст": 192,
    "вага": 87.75,
    "стегно": 56.2,
    "груди": 107.25,
    "рука": 37.3,
    "живіт": 93.25,
    "шия": null,
    "кість": 18.8,
    "сидниці": 102,
    "гомілка": 38.8,
    "Примітка": null
  }
];
